<template>
  <div class="dedicated-hr max-w-7xl mx-auto px-6 md:px-8 pt-4 lg:pt-20">
    <SectionHeader class="max-w-none md:max-w-xl mx-auto text-left">
      <template #header>
        <div class="text-left md:text-center mb-4">
          Expert guidance from your own <br />
          <span class="text-secondary">Dedicated HR Manager</span>
        </div>
      </template>
      <template #subheader>
        <div class="text-left md:text-center">
          Sometimes, you need the human touch. Bambee gives you a dedicated HR
          Manager who helps you craft HR policy and reach HR compliance.
        </div>
      </template>
    </SectionHeader>
    <div class="flex flex-col md:flex-row justify-center my-5 py-5">
      <div class="image-block pr-0 sm:pr-12 lg:pr-16">
        <HrmCard class="hrm-card mx-auto md:ml-auto mb-20 md:mb-0" />
      </div>
      <div class="list-block">
        <ul class="iconlist list-none max-w-none md:max-w-md">
          <li
            v-for="(item, index) in DedicatedHrList"
            :key="`icon-list-${index}`"
            class="iconlist-item flex mb-8 last-child:mb-0"
          >
            <HighlightedIcon
              size="large"
              :icon="item.icon"
              class="icon flex shrink-0 p-3 mr-6"
            />
            <div class="text-block shrink-1">
              <TypeBody
                :variant="$options.Typography.Body.MEDIUM"
                :weight="$options.Typography.Weights.STRONG"
                tag="p"
                class="text-block-title mb-2"
              >
                {{ item.title }}
              </TypeBody>
              <TypeBody
                :variant="$options.Typography.Body.MEDIUM"
                :weight="$options.Typography.Weights.REGULAR"
                tag="p"
                class="text-block-body"
              >
                {{ item.body }}
              </TypeBody>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { constants, HighlightedIcon, TypeBody } from '@bambeehr/pollen';
import HrmCard from './HomeHrmCard';
import SectionHeader from './SectionHeader';

import { DedicatedHrList } from '@/modules/HomePage/constants';

const { Typography } = constants;
export default defineComponent({
  name: 'HomeDedicatedHr',
  Typography,
  components: { HighlightedIcon, HrmCard, SectionHeader, TypeBody },
  setup() {
    return {
      DedicatedHrList,
    };
  },
});
</script>
